<template>
	<!-- 登录、注册弹框 -->
	<div class="tankuang">
		<div class="mask"></div>
		<div class="login-pop">
			<div class="close-pop close">
				<img src="../../assets/img/close2.png" alt />
			</div>
			<div class="login-bg">
				<img src="../../assets/img/logo.png" />
			</div>
			<div class="account">
				<div class="form">
					<div class="row">
						<input type="tel" placeholder="请输入手机号" class="phone-num" v-model="phone" v-on:input="getBtn" />
						<label>
							<i class="iconfont icon-guanbi-" @click="phoneNull"></i>
						</label>
					</div>
					<div class="row">
						<input type="tel" placeholder="请输入验证码" class="code" style="text-align: left;" v-model="code" v-on:input="getBtn" />
						<!-- <label>
							<i class="iconfont icon-guanbi-" @click="phoneNull"></i>
						</label> -->
						<span class="code" @click="sendCode">{{isSend}}</span>
					</div>
					<div class="row">
						<p v-if="isphone" class="warning">请输入正确的手机号</p>
						<input :type="type" placeholder="请设置密码（6-16位）" class="pass" v-model="pass" v-on:input="getBtn" />
						<label :class="{'active':isActive}">
							<i class="iconfont icon-guanbi-" style="float:left" @click="passNull"></i>
							<span class="pass-show iconfont" @click="showPass"></span>
						</label>
					</div>
					<p v-if="ispassword" class="warning">请输入6-16位数字字母组合密码!</p>
				</div>
				<div :class='["look-more"]' @click="register" style="display:block!important">注册</div>
				<p class="go-login" @click="showLogin">已有账号？去登录</p>
			</div>
		</div>
		<!-- <v-login v-if="log"></v-login> -->
	</div>
</template>
<script>
	import $ from "jquery";
	// import login from "../login/login";
	import common from "../../assets/comment/common.js";
	import Vue from "vue";
	Vue.prototype.common = common;
	var interval, yzm;
	export default {
		name: "Register",
		data() {
			return {
				isActive: false,
				type: "password",
				phone: "",
				pass: "",
				code: "",
				isphone: false,
				ispassword: false,
				iscodes: false,
				isPhones: "请输入正确的手机号",
				isSend: "发送验证码",
				isCode: "验证码不能为空",
				a: 0,
			};
		},
		methods: {
			showLogin() {
				this.$parent.name = "login";
			},
			showPass() {
				this.isActive = !this.isActive;
				if (this.isActive == true) {
					this.type = "text";
				} else {
					this.type = "password";
				}
			},
			getBtn() {
				if (this.phone != "" && this.pass != "") {
					this.a = 1;
				} else {
					this.a = 0;
				}
			},
			phoneNull() {
				this.phone = "";
			},
			passNull() {
				this.pass = "";
			},
			timer(time) {
				interval = setInterval(() => {
					time--;
					this.isSend = time + "s后重新发送";
					if (time <= 0) {
						clearInterval(interval);
						this.isSend = "获取验证码";
					}
				}, 1000);
				return;
			},
			sendCode(){
				var that = this
				this.$http.get('/api/user/001-transMessage',{params:{phone:this.phone}}).then(res=>{
					console.log(res)
					if(res.data.code==0){
						that.timer(60)
					}else{
						this.$message(res.data.msg);
					}
				})
			},
			register() {
				// this.$parent.$data.panelModal = false;
				var that = this
				if (this.phone == "" && this.pass == "" && this.code == "") {
					this.isphone = true;
					this.ispassword = true;
				}
				if (!this.common.verifyMobile(this.phone)) {
					this.isphone = true;
					return false;
				} else {
					this.isphone = false;
				}
				if (!this.common.verifyPass(this.pass)) {
					this.ispassword = true;
					return false;
				} else {
					this.ispassword = false;
				}
				// this.$http.get("/api/pcManager/001-register", {
				this.$http.get("/api/user/002-register", {
						params: {
							phone: this.phone,
							loginPwd: this.pass,
							smsCode: this.code,
						}
					})
					.then(res => {
						console.log(res, '注册成功');
						if (res.status == 200 && res.data.code == 0) {
							this.$message("注册成功");
							var data = res.data.rows[0];
							let userInfo = {
								id: data.id,
								phone: data.phone,
								token: data.token,
								role: data.role,
								status: '',
							};
							this.$store.commit("setUserInfo", userInfo);
							this.$emit("childUserInfo", {
								id: userInfo.id,
								phone: userInfo.phone,
								token: userInfo.token,
								role: userInfo.role,
								status: '',
								remark: '',
								type: 'register'
							});
							setTimeout(function(){
								// that.$parent.$parent.k = 0;
								that.$parent.attestation();
							},500)
							
							// this.$router.push({
							// 	path: "/iPage"
							// });
						} else {
							this.$message(res.data.msg)
						}

					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		mounted() {
			const self = this;
			// 关闭页面
			$(".close-pop").click(function() {
				self.$parent.$data.panelModal = false;
			});
		}
	};
</script>
<style scoped>
	.look-more {
		cursor: pointer;
	}

	.look-more.active {
		border: none;
		background: #ededed;
		color: #fff;

	}

	.login-pop .account .look-more {
		margin: 70px 0px 25px 0;
	}
</style>
